import Rollbar from 'rollbar'

import { User } from 'api/admin/users/types'
import { queryKeys } from 'api/consts'
import { queryClient } from 'contexts/reactQuery'

import type { Configuration } from 'rollbar'

export const getRollbarConfig = (): Configuration => {
  const id
    = queryClient.getQueryData<User>([queryKeys.user])?.uuid || null

  return {
    accessToken: 'c069ab5be3094f3797bf59685fa51d31',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: ['production', 'staging', 'review'].includes(
      import.meta.env.VITE_NODE_ENV,
    ),
    environment: import.meta.env.VITE_NODE_ENV,
    ignoredMessages: [
      'Network Error',
      'Request aborted',
      'Request failed with status code 401',
      /^Request failed with status code 5\d\d$/,
      'timeout exceeded',
    ],
    payload: {
      client: { javascript: { code_version: 'production-286' } },
      person: { id },
    },
    scrubFields: ['autoSubmitPrompt', 'presetPrompt', 'jwt_token', 'q'],
  }
}
export const rollbar = new Rollbar(getRollbarConfig())
